import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { completeGoogleDriveAuth } from "../../utils/Chatapi";

const GoogleDriveCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const run = async () => {
      const oauthCode = searchParams.get("code");
      const oauthState = searchParams.get("state");
      const oauthError = searchParams.get("error");

      let conversationId = "";
      try {
        const pending = sessionStorage.getItem("pending_gdrive_upload");
        if (pending) {
          const parsed = JSON.parse(pending);
          conversationId = parsed?.conversationId || "";
        }
      } catch (e) {
        console.warn("Could not read pending Google Drive upload:", e);
      }
      if (!conversationId) {
        conversationId = sessionStorage.getItem("titleId") || "";
      }

      const goBack = () => {
        if (conversationId) {
          navigate(`/afterchatbot?id=${conversationId}`, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      };

      if (oauthError) {
        toast.error(oauthError || "Google sign-in was cancelled");
        goBack();
        return;
      }

      // Google redirected here with code (frontend OAuth redirect URI).
      if (oauthCode && oauthState) {
        try {
          await completeGoogleDriveAuth(oauthCode, oauthState);
          sessionStorage.setItem("gdrive_just_connected", "1");
          toast.success("Google Drive connected!");
        } catch (err) {
          toast.error(err.message || "Google Drive connection failed");
          goBack();
          return;
        }
        goBack();
        return;
      }

      // Legacy: backend redirected here with ?gdrive=connected
      const status = searchParams.get("gdrive");
      const message = searchParams.get("msg") || "";
      if (status === "connected") {
        sessionStorage.setItem("gdrive_just_connected", "1");
        toast.success("Google Drive connected successfully!");
      } else if (status === "error") {
        toast.error(message || "Google Drive connection failed");
      }
      goBack();
    };

    run();
  }, [navigate, searchParams]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        color: "rgb(44 104 161)",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
      }}
    >
      <CircularProgress color="inherit" />
    </div>
  );
};

export default GoogleDriveCallback;
